import React from 'react';
export const CFIconChevronDown = {
    alias: 'chevron-down',
    defaultTitle: 'Chevron Down',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M12 16a.993.993 0 0 1-.64-.232l-6-5a1 1 0 1 1 1.28-1.536l5.37 4.477 5.363-4.316a1 1 0 0 1 1.254 1.558l-6 4.829A1 1 0 0 1 12 16Z' }))),
};
